export function labelForPrompt(target: string) {
  switch (target) {
    case "base_single":
      return "Base prompt · single";
    case "base_group":
      return "Base prompt · group";
    case "tool_guideline":
      return "Tool instruction";
    case "triage":
      return "Triage prompt";
    default:
      return target;
  }
}

export function labelForSubAgent(role: string) {
  switch (role) {
    case "orchestrator":
      return "Orchestrator";
    case "web":
      return "Web research executor";
    case "library":
      return "Library executor";
    case "browser":
      return "Authenticated browser executor";
    default:
      return role;
  }
}
